import { useEffect, useState } from "react";

import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import logger from "../../../utils/logger";



export const TrainingActionOnUser = ({ status, row, handleModal, alert, handleAlertContent, enabled, actionsPack }) => {


logger.debug('training status: ', status)

    let actionMock = actionsPack

   

    //! Funcion para concretar acciones sobre un usuario
    const actionsOnUser = (e, row, obj) => {
        e.stopPropagation() //👉 evita que dispare el click de la fila si hay

        //👉 activar un modal de interrogación
        if (alert) {
            handleModal('alert')
        }

        logger.debug('Actions row: ', { ...row })

        const newRow = {id:row?.id, email: row?.email, ...obj, url: actionMock?.url  }
        logger.info('new row: ', newRow)
        handleAlertContent(newRow)

    };

    const actionsIcons = (obj, row) => {

        logger.info('row en ActionOnUser: ', row)

        if (obj.hasOwnProperty('Ver')) {
            logger.info('si lo tiene ')
        }

        // logger.debug('OBJETO ES: ',obj)


        return <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-${obj.verb}`}>{obj.verb}</Tooltip>}
        >

            {obj.key === 5 ?

                <Link to={`/MemberDetail/${row.id}`}
                    className={`btn toTooltip-style ${obj.key === 5 ? 'spanVer' : ''}`}>
                    <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj.icon}</span>
                </Link>

                :

                <button
                    className={`btn toTooltip-style`}
                    onClick={(e) => actionsOnUser(e, row, obj)}>
                    <span className="material-icons notranslate mI-table" aria-hidden="true" role="none">{obj.icon}</span>
                </button>
            }




        </OverlayTrigger>
    };

    const renderActionButtons = (status, row) => {
        //? status proveniente de la API
        switch (status) {
            case 'Approved':

                return <>

                    {actionsIcons(actionMock.Rechazar, row)}      

                </>
            case 'PendingForApproval':
                return <>

                    {actionsIcons(actionMock.Rechazar, row)}
                    {actionsIcons(actionMock.Aprobar, row)}
             

                </>

            case 'Rejected':
                return <>

                    {actionsIcons(actionMock.Aprobar, row)}

                </>

            default:
                break;
        }
    };



    return (
        <>{renderActionButtons(status, row)}</>
    )
}


